import type { VideoMetrics } from '../../../types/dashboard'

export const VIDEO_ORDER = ['5s_viewed', '25_viewed', '50_viewed', '75_viewed', '100_viewed']

export const VIDEO_LABELS: Record<string, string> = {
  '5s_viewed':  '5s View',
  '25_viewed':  '25% View',
  '50_viewed':  '50% View',
  '75_viewed':  '75% View',
  '100_viewed': '100% View',
}

export function normalizeVideoMetrics(metrics: VideoMetrics): VideoMetrics {
  const result: VideoMetrics = {}
  for (const [key, value] of Object.entries(metrics)) {
    const normalized = key.replace('%', '').replace(/_view$/, '_viewed')
    result[normalized] = value
  }
  return result
}

export function activeVideoKeys(rowMetrics: VideoMetrics[]): string[] {
  return VIDEO_ORDER.filter(k =>
    rowMetrics.some(m => {
      const norm = normalizeVideoMetrics(m)
      return norm[k] !== undefined && norm[k].count > 0
    })
  )
}
